import * as types from './types'
import * as requests from '@cbgms/api/modules/products/requests'
import {
  GETPopularProductGroupsSearchAttributesResponse,
  GETProductBySupplierIdResponse,
  GETProductBySupplierIdsResponse,
  GETProductGroupResponse,
  GETProductGroupsCategoriesResponse,
  GETProductGroupsFilterAttributesResponse,
  GETProductGroupsSearchResponse,
  GETProductGroupsSearchResponseV2,
  GETProductRelationsByProductIDResponse,
  GETProductsByAttributesResponse,
  IFilter,
  IGetProductsBySearchAttributesParams,
  IProductAvailability,
  IProductIdentifier,
  IProductVehicleCompatibilityOutput,
  POSTProductBySupplierIdsBody
} from '@cbgms/api/modules/products'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { ProductIDType, ResultObjectType } from '@cbgms/api/modules/enums'
import { APIResponse } from '@cbgms/api'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { VPOMOrderManagementQueryOptions } from '@cbgms/api/modules/enums/vpom_order_management_query_options'

export const getProductGroups = (vehicleUUID?: string, orderAccountUUID?: string, skipVehicleSelection?: boolean) =>
  AsyncAction<GETProductGroupsCategoriesResponse>({
    type: [types.GET_PRODUCT_GROUPS, types.GET_PRODUCT_GROUPS_SUCCESS, types.GET_PRODUCT_GROUPS_FAILED],
    payload: {
      api: 'gms',
      vehicleUUID,
      request: requests.getProductGroups(vehicleUUID, orderAccountUUID),
      skipVehicleSelection
    }
  })
export const getHaynesproReqQty = (vehicleUUID?: string) =>
  AsyncAction<GETProductGroupsCategoriesResponse>({
    type: [types.GET_PRODUCT_GROUPS_SEARCH, types.GET_PRODUCT_GROUPS_SEARCH_SUCCESS, types.GET_PRODUCT_GROUPS_SEARCH_FAILED],
    payload: {
      api: 'gms',
      request: requests.getHaynesproReqQty(vehicleUUID),
      skipVehicleSelection: true
    }
  })
export const getProductGroupsSearch = (vehicleUUID?: string, orderAccountUUID?: string, searchTerm?: string) =>
  AsyncAction<GETProductGroupsSearchResponse>({
    type: [types.GET_PRODUCT_GROUPS_SEARCH, types.GET_PRODUCT_GROUPS_SEARCH_SUCCESS, types.GET_PRODUCT_GROUPS_SEARCH_FAILED],
    payload: {
      api: 'gms',
      request: requests.getProductGroupsSearch(vehicleUUID, orderAccountUUID, searchTerm)
    }
  })

export const getProductGroupsOrdersSearch = (
  query?: string,
  resultTypes?: ResultObjectType[],
  orderAccountUUID?: string,
  vehicleUUID?: string
) =>
  AsyncAction<GETProductGroupsSearchResponseV2>({
    type: [
      types.GET_PRODUCT_GROUPS_ORDERS_SEARCH,
      types.GET_PRODUCT_GROUPS_ORDERS_SEARCH_SUCCESS,
      types.GET_PRODUCT_GROUPS_ORDERS_SEARCH_FAILED
    ],
    payload: {
      api: 'gms',
      request: requests.getProductGroupsOrdersSearch(orderAccountUUID, query, resultTypes, vehicleUUID)
    }
  })

export const getProduct = (supplierID: string, idType: ProductIDType, orderAccountUUID: string, optionalVehicleUUID?: string) =>
  AsyncAction<GETProductBySupplierIdResponse>({
    type: [types.GET_PRODUCT, types.GET_PRODUCT_SUCCESS, types.GET_PRODUCT_FAILED],
    payload: {
      api: 'gms',
      request: requests.getProduct(supplierID, idType, orderAccountUUID, optionalVehicleUUID)
    }
  })

export const getProductsByIds = (body: POSTProductBySupplierIdsBody) =>
  createAsyncApiAction<GETProductBySupplierIdsResponse>('gms', {
    method: 'POST',
    url: '/modules/products/by-supplier-product-id',
    data: body
  })

export const getProducts = (productGroup: string, vehicleUUID: string, orderAccountUUID: string) =>
  AsyncAction<GETProductGroupResponse>({
    type: [types.GET_PRODUCTS, types.GET_PRODUCTS_SUCCESS, types.GET_PRODUCTS_FAILED],
    payload: {
      api: 'gms',
      vehicleUUID,
      request: requests.getProducts(productGroup, vehicleUUID, orderAccountUUID)
    }
  })

export const getProductsBySearchAttributes = (data: IGetProductsBySearchAttributesParams) =>
  AsyncAction<GETProductsByAttributesResponse>({
    type: [types.GET_PRODUCTS_BY_ATTRIBUTES, types.GET_PRODUCTS_BY_ATTRIBUTES_SUCCESS, types.GET_PRODUCTS_BY_ATTRIBUTES_FAILED],
    payload: {
      api: 'gms',
      vehicleUUID: data.OptionalVehicleUUID,
      request: requests.getProductsBySearchAttributes(data)
    }
  })

export const getSearchAttributesByProductGroup = (productGroupUUID: string, orderAccountUUID?: string) =>
  AsyncAction<GETProductGroupsFilterAttributesResponse>({
    type: [
      types.GET_SEARCH_ATTRIBUTES_BY_PRODUCT_GROUPS,
      types.GET_SEARCH_ATTRIBUTES_BY_PRODUCT_GROUPS_SUCCESS,
      types.GET_SEARCH_ATTRIBUTES_BY_PRODUCT_GROUPS_FAILED
    ],
    payload: {
      api: 'gms',
      request: requests.getProductGroupSearchAttributes(productGroupUUID, orderAccountUUID)
    }
  })

export const getPopularProductGroupSearchAttributes = (productGroupUUID: string, orderAccountUUID?: string) =>
  createAsyncApiAction<GETPopularProductGroupsSearchAttributesResponse>(
    'gms',
    requests.getPopularProductGroupSearchAttributes(productGroupUUID, orderAccountUUID)
  )

export const searchProducts = (orderAccountUUID: string, searchTerm: string, excludeAvailability = false, QueryOptions?: string) =>
  AsyncAction<GETProductGroupResponse>({
    type: [types.SEARCH_PRODUCTS, types.SEARCH_PRODUCTS_SUCCESS, types.SEARCH_PRODUCTS_FAILED],
    payload: {
      api: 'gms',
      request: requests.searchProducts(orderAccountUUID, searchTerm, excludeAvailability, QueryOptions)
    }
  })

export const searchRMAProducts = (orderAccountUUID: string, searchTerm: string, excludeAvailability = false, QueryOptions?: string) =>
  AsyncAction<GETProductGroupResponse>({
    type: [types.SEARCH_PRODUCTS, types.SEARCH_PRODUCTS_SUCCESS, types.SEARCH_PRODUCTS_FAILED],
    payload: {
      api: 'gms',
      request: requests.searchRMAProducts(orderAccountUUID, searchTerm, excludeAvailability, QueryOptions)
    }
  })

export const setActiveFilters = (key: string, activeFilters: string[]) => {
  return {
    type: types.SET_PRODUCT_FILTER,
    payload: {
      key,
      activeFilters
    }
  }
}

export const getGenericProducts = (genericArticlesID: string, vehicleUUID: string, orderAccountUUID: string, excludeAvailability = false) =>
  AsyncAction<GETProductGroupResponse>({
    type: [types.GET_GENERIC_PRODUCTS, types.GET_GENERIC_PRODUCTS_SUCCESS, types.GET_GENERIC_PRODUCTS_FAILED],
    payload: {
      api: 'gms',
      vehicleUUID,
      request: requests.getGenericProducts(genericArticlesID, vehicleUUID, orderAccountUUID, excludeAvailability)
    }
  })

export const getProductAvailability = (
  orderAccountUUID: string,
  productIDs: IProductIdentifier[],
  queryOptions?: VPOMOrderManagementQueryOptions
) =>
  AsyncAction<APIResponse<IProductAvailability[]>>({
    type: [types.GET_PRODUCT_AVAILABILITY, types.GET_PRODUCT_AVAILABILITY_SUCCESS, types.GET_PRODUCT_AVAILABILITY_FAILED],
    payload: {
      api: 'gms',
      request: requests.getProductAvailability(orderAccountUUID, productIDs, queryOptions)
    }
  })

export const validateActiveFilters = (filters: IFilter[]) => ({
  type: types.VALIDATE_PRODUCT_FILTER,
  payload: filters
})

export const resetProductFilter = () => {
  return {
    type: types.RESET_PRODUCT_FILTER
  }
}

export const resetProduct = () => ({
  type: types.RESET_PRODUCT
})

export const resetProducts = () => ({
  type: types.RESET_PRODUCTS
})

export const getProductVehicleCompatibilityByProductID = (
  id: string,
  idType: string,
  productGroupId: string,
  orderAccountUUID: string,
  optionalVehicleUUID?: string
) =>
  AsyncAction<APIResponse<IProductVehicleCompatibilityOutput>>({
    type: [
      types.GET_PRODUCT_VEHICLE_COMPATIBILITY,
      types.GET_PRODUCT_VEHICLE_COMPATIBILITY_SUCCESS,
      types.GET_PRODUCT_VEHICLE_COMPATIBILITY_FAILED
    ],
    payload: {
      api: 'gms',
      request: requests.getProductVehicleCompatibilityByProductID(id, idType, productGroupId, orderAccountUUID, optionalVehicleUUID)
    }
  })

export const getProductRelationsByProductID = (id: string, idType: string, orderAccountUUID: string, optionalVehicleUUID?: string) =>
  AsyncAction<GETProductRelationsByProductIDResponse>({
    type: [types.GET_RELATED_PRODUCTS, types.GET_RELATED_PRODUCTS_SUCCESS, types.GET_RELATED_PRODUCTS_FAILED],
    payload: {
      api: 'gms',
      request: requests.getProductRelationsByProductID(id, idType, orderAccountUUID, optionalVehicleUUID)
    }
  })

export const getDashboardLicensePlates = () =>
  createAsyncApiAction<GETProductGroupResponse>('gms', {
    method: 'GET',
    url: '/modules/products/product-group/licence-plates'
  })

export const getRefurbishmentFormTemplates = (wholesalerUUID: string) =>
  AsyncAction<APIResponse<any>>({
    type: [
      types.GET_REFURBISHMENT_FORM_TEMPLATES,
      types.GET_REFURBISHMENT_FORM_TEMPLATES_SUCCESS,
      types.GET_REFURBISHMENT_FORM_TEMPLATES_FAILED
    ],
    payload: {
      api: 'gms',
      request: requests.getRefurbishmentFormTemplates(wholesalerUUID)
    }
  })

export const getFormJSON = (wholesalerUUID: string, formUUID: string) =>
  AsyncAction<APIResponse<any>>({
    type: [types.GET_FORM_JSON, types.GET_FORM_JSON_SUCCESS, types.GET_FORM_JSON_FAILED],
    payload: {
      api: 'gms',
      request: requests.getFormJSON(wholesalerUUID, formUUID)
    }
  })
export const postRefurbishmentForm = (wholesalerUUID: string, formUUID: string, data: any) =>
  AsyncAction<APIResponse<any>>({
    type: [types.GET_PRODUCT_AVAILABILITY, types.GET_PRODUCT_AVAILABILITY_SUCCESS, types.GET_PRODUCT_AVAILABILITY_FAILED],
    payload: {
      api: 'gms',
      request: requests.postRefurbishmentForm(wholesalerUUID, formUUID, data)
    }
  })

export { getVehicleTyreSuggestion } from '@cbgms/api/modules/products/actions'
